import React from "react";
import logo from "./logo.svg";
import "./App.css";
import CBE_logo from "./images/CBE_logo.png";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useNavigate,
  Navigate,
  Link,
} from "react-router-dom";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import Header from "./Page/Header";

import { PublicClientApplication } from "@azure/msal-browser";
import { NavigationClient } from "@azure/msal-browser";
import { useIsAuthenticated, MsalProvider } from "@azure/msal-react";
import { CustomNavigationClient } from "./Utils/CustomNavigationClient";
import { AdminProvider } from "./Utils/AdminContext";
import CreateUser from "./Page/Admin/User/CreateUser";
import EditUser from "./Page/Admin/User/EditUser";
import ListOfUsers from "./Page/Admin/User/ListOfUsers";
import ListOfQuestionnaires from "./Page/ListOfQuestionnaires";
import ListOfProjects from "./Page/Admin/Project/ListOfProjects";
import EditProject from "./Page/Admin/Project/EditProject";
import UpdateQuestionnaire from "./Page/UpdateQuestionnaire";
import CreateProject from "./Page/Admin/Project/CreateProject";
import ListOfUserProjectsRoles from "./Page/Admin/UserProject/ListOfUserProjectsRoles";
import ProtectedAdminRoute from "./Utils/ProtectedAdminRoute";
interface appInterface {
  instance: PublicClientApplication;
}
const App = ({ instance }: appInterface) => {
  const navigate = useNavigate();
  const navigationClient = new CustomNavigationClient(navigate);
  instance.setNavigationClient(navigationClient);
  const isAuthenticated = useIsAuthenticated();

  return (
    <MsalProvider instance={instance}>
      <AdminProvider >
      <div className="App">
       
        <Routes>
          <Route
            path="/"
            element={
              <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <ListOfQuestionnaires />
              </MsalAuthenticationTemplate>
            }
          />
          <Route
            path="/:statusId?"
            element={
              <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <ListOfQuestionnaires />
              </MsalAuthenticationTemplate>
            }
          />
          <Route
            path="/UpdateProject/:projectId"
            element={
              <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                <UpdateQuestionnaire />
              </MsalAuthenticationTemplate>
            }
          />
          <Route
            path="/Admin"
            element={
              <ProtectedAdminRoute>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                  <ListOfUsers />
                </MsalAuthenticationTemplate>
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/Admin/User/:userId"
            element={
              <ProtectedAdminRoute>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                  <EditUser />
                </MsalAuthenticationTemplate>
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/Admin/User/Create"
            element={
              <ProtectedAdminRoute>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                  <CreateUser />
                </MsalAuthenticationTemplate>
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/Admin/Projects"
            element={
              <ProtectedAdminRoute>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                  <ListOfProjects />
                </MsalAuthenticationTemplate>
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/Admin/Project/:projectId"
            element={
              <ProtectedAdminRoute>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                  <EditProject />
                </MsalAuthenticationTemplate>
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/Admin/Project/Create"
            element={
              <ProtectedAdminRoute>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                  <CreateProject />
                </MsalAuthenticationTemplate>
              </ProtectedAdminRoute>
            }
          />
          <Route
            path="/Admin/Roles"
            element={
              <ProtectedAdminRoute>
                <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
                  <ListOfUserProjectsRoles />
                </MsalAuthenticationTemplate>
              </ProtectedAdminRoute>
            }
          />
        </Routes>
      </div>
      <div className="version-display">v1.0.0</div>
      </AdminProvider>
    </MsalProvider>
  );
};

export default App;
